import { useState, useEffect } from 'react';
import '~/apps/App.css';
import '~/apps/common.css';
import '../directorySearch.css'
import Grid from '@mui/material/Grid';
import Hits from '../components/Hits.js';
import SearchBox from '../components/SearchBox.js';
import Results from '../components/Results.js';

import title from "~/helpers/title.js";
import {liteClient as algoliasearch} from 'algoliasearch/lite';
import {
    InstantSearch,
    Configure,
    Highlight,
} from 'react-instantsearch';
import { history } from 'instantsearch.js/es/lib/routers/index.js';
import queryStrReader from '~/helpers/queryStrReader.js';
import queryStrBuilder from '~/helpers/queryStrBuilder.js';
import Routing from "fos-routing";
import apiInitObject from "~/helpers/apiInitObject.js";
import respHandler from "~/helpers/respHandler.js";
import ErrorBoundary from "../components/ErrorBoundary.js";
import {useLocation, useNavigate} from "react-router-dom";

// correct api key -- ab22c79867e4fa9ccede09f3c14cc3e0
const searchClient = algoliasearch(
    '05XYDC2NJE',
    'ab22c79867e4fa9ccede09f3c14cc3e0'
);

const DEBOUNCE_TIME = 400;
const INDEX_NAME = process.env.DEV ||
window.location.href.includes('-multidev') ||
window.location.href.includes('-sandbox') ||
window.location.href.includes('-local') ||
window.location.href.includes('-dev') ? 'dev_DIRECTORYSEARCH' : 'prod_DIRECTORYSEARCH';

function Main(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const pageTitle = "People Search";
    const defaultHits = 20;

    const [locations, setLocations] = useState([]);
    const [hitsPerPage, setHitsPerPage] = useState(defaultHits);
    // We don't want to push to history after using the browser back or forward

    const updateHitsPerPage = hitsPerPage => {
        setHitsPerPage(hitsPerPage || defaultHits);
    };

    useEffect(() => {
        document.title = title({title: 'SF State Search - ' + pageTitle});

        fetch(Routing.generate(
            '_directorysearchapi_locations',
            null,
            process.env.DEV
        ), apiInitObject)
            .then(respHandler)
            .then(data => {
                setLocations(data.data);
            }).catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
            throw err;
        });
    }, []);

    const searchState = {[INDEX_NAME]: (queryStrReader(location.search) || {})};

    const hasSearchTerm = searchState[INDEX_NAME].query && searchState[INDEX_NAME].query.trim().length > 0;
    const hasSearchByDepartment = searchState[INDEX_NAME].menu && searchState[INDEX_NAME].menu["positions.dept_title"];

    const routing = {
        router: history({
            createURL: ({routeState}) => {
                routeState = routeState[INDEX_NAME] || {};
                if (queryStrBuilder(routeState) === '?configure[hitsPerPage]=20') return '';
                return location.pathname + queryStrBuilder(routeState);
            },
            parseURL: ({location}) => {
                return {[INDEX_NAME]: (queryStrReader(location.search) || {})};
            },
            writeDelay: DEBOUNCE_TIME,
            push: url => {
                if (url === location.pathname + location.search || url.trim() === '') return;
                navigate(url);
            },
            cleanUrlOnDispose: false,
        }),
        // Needed to generate the hitsPerPage in the URL
        stateMapping: {
            stateToRoute: (uiState) => {
                return uiState;
            },
            routeToState: (routeState) => {
                return routeState;
            }
        }
    };

    return <div className="App directorysearch">
        <ErrorBoundary>
            <InstantSearch
                indexName={INDEX_NAME}
                searchClient={searchClient}
                routing={routing}
                future={{preserveSharedStateOnUnmount: true}}
            >
                <Grid container spacing={8}>
                    <Grid size={{xs: 12, lg: 10}} className="full-width">
                        <h1>People Search</h1>

                        <Configure hitsPerPage={hitsPerPage}/>
                        <SearchBox
                            autoFocus
                            delay={DEBOUNCE_TIME}
                            translations={{
                                placeholder: 'Enter your search term or name',
                            }}
                        />

                        {/*
                            The role "region" landmark role is used to identify an area in the document that the author
                            has identified as significant. It is used to provide a generic landmark for people to be
                            able to navigate to easily when none of the other landmark roles are appropriate. By
                            classifying and labeling sections of a page, structural information conveyed visually
                            through layout is represented programmatically. Screen readers use landmark roles to provide
                            keyboard navigation to important sections of a page.
                        */}
                        <div role="region" aria-live="polite">
                            <Results hitsPerPage={hitsPerPage} indexName={INDEX_NAME}/>

                            {hasSearchTerm || hasSearchByDepartment ?
                                <Hits
                                    hitsPerPage={hitsPerPage}
                                    updateHitsPerPage={updateHitsPerPage}
                                    locations={locations}
                                    hitComponent={({hit}) => <Highlight attribute="hit" hit={hit}/>}
                                /> : null
                            }
                        </div>
                    </Grid>
                </Grid>
            </InstantSearch>
        </ErrorBoundary>
    </div>;
}

export default Main;
